module.exports = __webpack_public_path__ + "static/assets/2581e1caab101b1bf83e798ace6a8686.png";